<template>
  <div id="app" v-if="display">
    <sp-header
      :user="userInfo"
      :locales="locales"
      :logout="logout">
      <span slot="logo" class="sp-logo">
        <div>{{ $i18n('Acribus') }}</div>
      </span>
    </sp-header>
    <sp-menu class="sp-left-side" :data="menuData"></sp-menu>
    <div class="sp-right-side">
      <article>
        <sp-breadcrumb :data="menuData"></sp-breadcrumb>
        <router-view></router-view>
      </article>
    </div>
  </div>
</template>

<script>
  import spHeader from '../packages/components/Header/index'
  import spMenu from '../packages/components/Menu/index.js'
  import spBreadcrumb from '../packages/components/Breadcrumb/index.js'

  import locales from './lang/index'

  import menu from './mock/menu'

  export default {
    data() {
      return {
        locales,
        display: true,
        userInfo: {
          email: 'jon.doe@examples.com'
        },
        menuData: menu
      }
    },
    components: {
      spHeader,
      spMenu,
      spBreadcrumb
    },
    methods: {
      async logout() {
        this.$message('logout clicked')
      }
    }
  }
</script>

<style>
.sp-logo {
  font-size: 24px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// examples/App.vue